import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	searchErrorDescription: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.cmdb-objects.search-error-description',
		defaultMessage:
			'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
		description:
			'Error message informing the user that there was an error while fetching CMDB objects.',
	},
	searchErrorTitle: {
		id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.cmdb-objects.search-error-title',
		defaultMessage: "We couldn't fetch any objects for this field",
		description:
			'Error title informing the user that there was an error while fetching CMDB objects.',
	},
});
